<template>
  <a
    class="wa-float"
    :href="href"
    target="_blank"
    rel="noopener"
  >
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M20.5 3.5A11 11 0 0 0 2.1 17.6L1 23l5.6-1.1A11 11 0 0 0 20.5 3.5zm-8.5 17a9.1 9.1 0 0 1-4.6-1.3l-.3-.2-3.3.7.7-3.2-.2-.3A9.1 9.1 0 1 1 12 20.5zm5-6.8c-.3-.1-1.6-.8-1.9-.9s-.4-.1-.6.1-.7.9-.9 1.1-.3.2-.6.1a7.4 7.4 0 0 1-2.2-1.4 8 8 0 0 1-1.5-1.9c-.2-.3 0-.4.1-.6l.5-.6c.1-.2.1-.3 0-.5l-.9-2.1c-.2-.6-.5-.5-.6-.5h-.5c-.2 0-.5.1-.8.4s-1 1-1 2.5 1.1 2.9 1.2 3.1a12.3 12.3 0 0 0 4.2 3.7c.6.3 1 .5 1.4.6.6.3 1.1.2 1.5.1.5-.1 1.6-.7 1.8-1.3s.2-1.2.2-1.3-.1-.2-.4-.3z"
      />
    </svg>
    <span class="wa-float__label">{{ t("nav.wa") }}</span>
  </a>
</template>

<script>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { whatsappHref } from "@/data/company";

export default {
  name: "WhatsAppFloat",
  setup() {
    const { t } = useI18n();
    const href = computed(() => whatsappHref(t("contact.waPrefill")));
    return { href, t };
  },
};
</script>
